<a
  [href]="item.link!"
  class="link">
  <ng-content />
</a>
